<span class="icon" [matTooltip]="channal" class="icon--{{channal | lowercase}}"></span>